<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12">
        <q-tabs v-model="tab">
          <q-tab name="general" label="General" />
          <!-- <q-tab name="sections" label="Sections" /> -->
          <q-tab name="settings" label="Settings" />
          <q-tab name="sessions" label="Sessions" />
          <q-tab name="arenas" label="Arenas" />
          <!-- <q-tab name="divisions" label="Divisions" /> -->
          <q-tab name="events" label="Events" />
          <q-tab name="questions" label="Questions" />
          <!-- <q-tab name="quota" label="Quota Rules" /> -->
          <q-tab name="limits" label="Limits" />
          <q-tab name="downloads" label="Reports" />
          <q-tab name="invoicing" label="Invoicing" />
          <q-tab name="reminders" label="Reminders" />
          <q-tab name="entries" label="Entries" />
        </q-tabs>
      </div>
    </div>
    <div class="row" v-if="tab == 'general'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">General</h6>
      </div>

      <div class="col-12" :class="{ 'col-md-8': formData.id }">
        <div class="row">
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.competition_name"
              label="Competition Name"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              label="Agency"
              readonly
              v-model="formData.agency"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12  col-sm-6  q-pa-xs">
            <q-select
              :options="[
                'Northern Region',
                'Eastern Region',
                'Central Region',
                'Southern Region',
                'National'
              ]"
              v-model="formData.sls_region"
              label="SLS Region"
              v-bind="siteCFG.fields.general"
            >
            </q-select>
          </div>

          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.contactName"
              label="Contact Name"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-account" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-select
              v-model="formData.competition_type"
              label="Sport Type"
              v-bind="siteCFG.fields.general"
              :options="competitionTypes"
              option-label="label"
              option-value="value"
              emit-value
              map-options
            >
            </q-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-select
              v-model="formData.secondary_type"
              label="Type"
              v-bind="siteCFG.fields.general"
              :options="[
                { label: 'IRB', value: 'IRB' },
                { label: 'Surf Boat', value: 'Surf Boat' },
                { label: 'Surf Canoe', value: 'Surf Canoe' },
                { label: 'Senior', value: 'Senior' },
                { label: 'Junior', value: 'Junior' },
                { label: 'Masters', value: 'Masters' }
              ]"
              option-label="label"
              option-value="value"
              emit-value
              map-options
            >
            </q-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-input
              v-model="formData.phone"
              label="Phone"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-phone" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-input
              v-model="formData.mobile"
              label="Mobile"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-cellphone" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.email"
              label="Email"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-email" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.venue"
              label="Venue"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.youtubeVideoID"
              label="Youtube Video"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-youtube" />
              </template>
            </q-input>
          </div>
          <div class="col-12 q-pa-xs">
            <q-btn-dropdown
              :color="statusColors[formData.status]"
              class="full-width"
              :label="formData.status"
            >
              <q-list>
                <q-item
                  v-for="(status, index) in competitionStatusOptions"
                  :key="`statusOption_${index}`"
                  clickable
                  v-close-popup
                  @click="
                    status.value == 'ARCHIVED'
                      ? null
                      : (formData.status = status.value)
                  "
                >
                  <q-item-section>
                    <q-item-label>{{ status.label }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            <!-- <q-select
              v-model="formData.status"
              label="Status"
              :options="competitionStatusOptions"
              option-label="label"
              option-value="value"
              map-options
              :emit-value="true"
              v-bind="siteCFG.fields.general"
            >
            </q-select> -->
          </div>
        </div>
      </div>
      <div v-if="formData.id" class="col-12 col-md-4">
        <div class="row">
          <div class="col-12">
            <div
              v-if="(changeImage || !formData.logoUrl) && formData.id"
              style="margin: auto; width: 300px"
            >
              <croppa
                ref="imgCroppa"
                :height="200"
                :width="300"
                :show-remove-button="true"
                v-model="myCroppa"
                remove-button-color="#68c6d2"
                :show-loading="true"
                :loading-size="50"
                crossOrigin="anonymous"
                :quality="2"
                :prevent-white-space="false"
                :placeholder="'Choose an image (300x200)'"
                :placeholder-font-size="15"
              >
              </croppa>
              <q-btn
                class="full-width"
                color="negative"
                label="Cancel"
                @click="
                  changeImage = false;
                  myCroppa = null;
                "
                v-if="formData.id"
              >
              </q-btn>
            </div>
            <div v-else style="margin: auto; width: 300px">
              <q-img
                :src="formData.logoUrl"
                style="height: 200px; width: 300px"
                v-if="formData.id"
              >
              </q-img>
              <q-btn
                class="full-width"
                color="primary"
                label="Change"
                @click="changeImage = true"
                v-if="formData.id"
              >
              </q-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 q-mt-md q-px-xs">
        <q-card flat bordered>
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Key Dates</h6>
            </div>
          </div>
          <div class="row q-pa-md">
            <div class="col-12 col-md-6 q-px-xs">
              <q-input
                label="Competition Start Date"
                v-bind="siteCFG.fields.general"
                v-model="formData.start_date"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date v-model="formData.start_date" mask="YYYY-MM-DD">
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-12 col-md-6 q-px-xs">
              <q-input
                label="Competition Finish Date"
                v-bind="siteCFG.fields.general"
                v-model="formData.end_date"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="formData.end_date"
                        mask="YYYY-MM-DD HH:mm"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                  <q-icon name="access_time" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-time
                        v-model="formData.end_date"
                        mask="YYYY-MM-DD HH:mm"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-time>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-12 col-md-6 q-px-xs">
              <q-input
                label="Entries Close"
                v-bind="siteCFG.fields.general"
                v-model="formData.entriesCloseDate"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="formData.entriesCloseDate"
                        mask="YYYY-MM-DD HH:mm"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                  <q-icon name="access_time" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-time
                        v-model="formData.entriesCloseDate"
                        mask="YYYY-MM-DD HH:mm"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-time>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-12 col-md-6 q-px-xs">
              <q-input
                label="Calculate age as at"
                v-bind="siteCFG.fields.general"
                v-model="formData.age_reference_date"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="formData.age_reference_date"
                        mask="YYYY-MM-DD"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-12 q-px-xs">
              <q-input
                label="Refresher valid as at"
                v-bind="siteCFG.fields.general"
                v-model="formData.refresher_reference_date"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="formData.refresher_reference_date"
                        mask="YYYY-MM-DD"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
          </div>
        </q-card>
      </div>
      <div class="col-12 col-md-6 q-mt-md q-px-xs">
        <q-card flat bordered>
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Entry Form Type</h6>
            </div>
          </div>
          <div class="row q-pa-md">
            <div class="col-12 q-px-xs">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label="Team Events"
                v-model="formData.teamsPlayersEntries"
              />
            </div>
            <!-- <div class="col-12 q-px-xs">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label="Multiple athletes per event (eg Road Race/Multisport Entry Form)"
                v-model="formData.multipleAthletesPerEvent"
              />
            </div> -->
            <div class="col-12 q-px-xs">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label="Individual Events"
                v-model="formData.multipleEventsPerAthlete"
              />
            </div>
            <div class="col-12 q-px-xs">
              <q-checkbox
                label="Show Entries to Public"
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                v-model="formData.showEntriesToPublic"
              />
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <div class="row" v-if="tab == 'settings'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">Settings</h6>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12 q-pa-xs">
            <q-card flat bordered>
              <div class="row q-px-md q-pt-md">
                <div class="col-12">
                  <h6 class="q-my-none q-mt-xs">Settings</h6>
                </div>
              </div>
              <div class="row q-pa-md">
                <div class="col-12 col-sm-6 q-pa-xs">
                  <q-input
                    v-model="formData.default_num_lanes"
                    label="Num Lanes"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 q-pa-xs">
                  <q-input
                    v-model="formData.first_lane_no"
                    label="First Lane No"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 q-pa-xs">
                  <q-select
                    v-model="formData.pool_length"
                    label="Pool Length"
                    v-bind="siteCFG.fields.general"
                    :options="poolLengthOptions"
                    option-label="label"
                    option-value="value"
                    map-options
                    :emit-value="true"
                  >
                  </q-select>
                </div>
                <div class="col-12 col-sm-6 q-pa-xs">
                  <q-select
                    v-model="formData.lane_order_type"
                    label="Seeding"
                    v-bind="siteCFG.fields.general"
                    :options="['Random', 'First Lane Out', 'Centre Lane Out']"
                    option-label="label"
                    option-value="value"
                    map-options
                    :emit-value="true"
                  >
                  </q-select>
                </div>
                <div class="col-12 q-px-xs">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Use qualifying times"
                    v-model="formData.qualifyingTimesOrMarks"
                  />
                </div>
                <div class="col-12 q-px-xs">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Live Results Points Table"
                    v-model="formData.lr_showPoints"
                  />
                </div>
                <div class="col-12 q-px-xs">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Live Results Medals Table"
                    v-model="formData.lr_showMedals"
                  />
                </div>
                <div class="col-12 q-px-xs">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Live Results Points & Medals after event"
                    v-model="formData.lr_showPAndMAfterFinished"
                  />
                </div>
                <div class="col-12 q-px-xs">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Events Drawn before Event"
                    v-model="formData.preDrawnEvents"
                  />
                </div>
              </div>
            </q-card>
          </div>
          <div class="col-12 q-pa-xs">
            <q-card flat bordered>
              <div class="row q-px-md q-pt-md">
                <div class="col-12">
                  <h6 class="q-my-none q-mt-xs">Quota</h6>
                </div>
              </div>
              <div class="row q-pa-md">
                <div class="col-12 q-px-xs">
                  <q-input
                    v-show="false"
                    v-model="formData.entriesPerAssociation"
                    label="Max Num of entries per Association"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                  <q-input
                    v-model="formData.entriesPerAssociation"
                    label="Max Num of entries per Association"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
                <div class="col-12 q-px-xs">
                  <q-input
                    v-show="false"
                    v-model="formData.eventsPerAthlete"
                    label="Max Events per Athlete"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                  <q-input
                    v-model="formData.eventsPerAthlete"
                    label="Max Events per Athlete"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
              </div>
            </q-card>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-card flat bordered class="full-height">
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Info Fields</h6>
            </div>
          </div>
          <!-- <div class="col-12 q-pa-md">
            <q-input
              type="textarea"
              label="Notice Top"
              v-bind="siteCFG.fields.general"
              v-model="formData.noticeTop"
            >
            </q-input>
          </div> -->
          <div class="col-12 q-px-md">
            <!-- <tiptap
              v-model="formData.entryInformationSection"
              class="q-px-lg q-py-md q-mx-auto"
              contentWidth="650px"
              barWidth="800px"
              borderWidth="700px"
            /> -->
            <q-editor
              v-model="formData.entryInformationSection"
              :dense="$q.screen.lt.md"
              :toolbar="[
                [
                  {
                    label: $q.lang.editor.align,
                    icon: $q.iconSet.editor.align,
                    fixedLabel: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                  },
                  {
                    label: $q.lang.editor.align,
                    icon: $q.iconSet.editor.align,
                    fixedLabel: true,
                    options: ['left', 'center', 'right', 'justify']
                  }
                ],
                [
                  'bold',
                  'italic',
                  'strike',
                  'underline',
                  'subscript',
                  'superscript'
                ],
                ['token', 'hr', 'link', 'custom_btn'],
                ['print', 'fullscreen'],
                [
                  {
                    label: $q.lang.editor.formatting,
                    icon: $q.iconSet.editor.formatting,
                    list: 'no-icons',
                    options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                  },
                  {
                    label: $q.lang.editor.fontSize,
                    icon: $q.iconSet.editor.fontSize,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'size-1',
                      'size-2',
                      'size-3',
                      'size-4',
                      'size-5',
                      'size-6',
                      'size-7'
                    ]
                  },
                  {
                    label: $q.lang.editor.defaultFont,
                    icon: $q.iconSet.editor.font,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'default_font',
                      'arial',
                      'arial_black',
                      'comic_sans',
                      'courier_new',
                      'impact',
                      'lucida_grande',
                      'times_new_roman',
                      'verdana'
                    ]
                  },
                  'removeFormat'
                ],
                ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                ['undo', 'redo'],
                ['viewsource']
              ]"
              :fonts="{
                arial: 'Arial',
                arial_black: 'Arial Black',
                comic_sans: 'Comic Sans MS',
                courier_new: 'Courier New',
                impact: 'Impact',
                lucida_grande: 'Lucida Grande',
                times_new_roman: 'Times New Roman',
                verdana: 'Verdana'
              }"
            />
          </div>
          <div class="col-12 q-pa-md">
            <q-input
              type="textarea"
              label="Notice Bottom"
              v-bind="siteCFG.fields.general"
              v-model="formData.noticeBottom"
            >
            </q-input>
          </div>
        </q-card>
      </div>
      <div class="col-12 q-pa-xs">
        <q-card flat bordered>
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Competition Points</h6>
            </div>
          </div>

          <div class="row q-pa-md">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12">Individual Events</div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.finalsPoints_id"
                    label="Finals Points"
                    @changed="val => (formData.finalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.semiFinalsPoints_id"
                    label="Semi Finals Points"
                    @changed="val => (formData.semiFinalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.quaterFinalsPoints_id"
                    label="Quater Finals Points"
                    @changed="val => (formData.quaterFinalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.heatsPoints_id"
                    label="Heats Points"
                    @changed="val => (formData.heatsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.roundsPoints_id"
                    label="Rounds Points"
                    @changed="val => (formData.roundsPoints_id = val)"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12">Team Events</div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.teamFinalsPoints_id"
                    label="Finals Points"
                    @changed="val => (formData.teamFinalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.teamSemiFinalsPoints_id"
                    label="Semi Finals Points"
                    @changed="val => (formData.teamSemiFinalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.teamQuaterFinalsPoints_id"
                    label="Quater Finals Points"
                    @changed="val => (formData.teamQuaterFinalsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.teamHeatsPoints_id"
                    label="Heats Points"
                    @changed="val => (formData.teamHeatsPoints_id = val)"
                  />
                </div>
                <div class="col-12 q-pa-xs">
                  <assign-points-table
                    :id="formData.teamRoundsPoints_id"
                    label="Rounds Points"
                    @changed="val => (formData.teamRoundsPoints_id = val)"
                  />
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <div class="row" v-if="tab == 'sessions'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Competition Sessions
          <q-btn
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addSession"
            :loading="addSessionLoading"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>
          <q-input
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="sessionsSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div class="col-12" style="height: calc(100vh - 285px) !important">
        <datatable
          :filter="sessionsSearch"
          :flat="true"
          :data="sessions"
          :columns="sessionColumns"
          @rowDoubleClick="sessionDoubleClick"
        >
          <template slot="body-cell-name" slot-scope="data">
            <q-td :props="data.props">
              <q-input
                label="Session Name"
                hide-label
                v-bind="siteCFG.fields.general"
                v-model="data.props.row.name"
                @input="updateSessionRow(data.props.row)"
                dense
                :debounce="1000"
              >
              </q-input>
            </q-td>
          </template>
          <template slot="body-cell-idx" slot-scope="data">
            <q-td :props="data.props">
              <q-input
                label="IDX"
                hide-label
                v-bind="siteCFG.fields.general"
                v-model="data.props.row.idx"
                @input="updateSessionRow(data.props.row)"
                dense
                :debounce="1000"
              >
              </q-input>
            </q-td>
          </template>
          <template slot="body-cell-active" slot-scope="data">
            <q-td :props="data.props">
              <q-icon
                v-if="!settingSessionActive"
                @click="setSessionActive(data.props.row)"
                :name="
                  `mdi-${
                    data.props.row.active
                      ? 'check-circle-outline'
                      : 'close-circle-outline'
                  }`
                "
                :color="data.props.row.active ? 'positive' : 'negative'"
                size="sm"
              >
                <q-tooltip>
                  Session is
                  {{
                    data.props.row.active
                      ? "Active"
                      : "Inactive (Click to make active)"
                  }}
                </q-tooltip>
              </q-icon>
              <q-spinner-dots v-else color="info" size="sm" class="q-mr-sm" />
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingSessionID == data.props.row.id"
                @click="removeSession(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Session</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
    <div class="row" v-if="tab == 'arenas'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Competition Arenas
          <q-btn
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addArena"
            :loading="addArenaLoading"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>
          <q-input
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="sessionsSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div class="col-12" style="height: calc(100vh - 285px) !important">
        <datatable
          :filter="arenasSearch"
          :flat="true"
          :data="arenas"
          :columns="arenaColumns"
          @rowDoubleClick="arenaDoubleClick"
        >
          <template slot="body-cell-name" slot-scope="data">
            <q-td :props="data.props">
              <q-input
                label="Arena Name"
                hide-label
                v-bind="siteCFG.fields.general"
                v-model="data.props.row.name"
                @input="updateArenaRow(data.props.row)"
                dense
                :debounce="1000"
              >
              </q-input>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingArenaID == data.props.row.id"
                @click="removeArena(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Arena</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
    <div class="row" v-if="tab == 'events'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Events
          <q-btn
            v-if="!addEvent && !editEvent"
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addEvent = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>

          <!-- <q-btn
            v-if="!addEvent && !editEvent"
            class="q-ml-md"
            color="secondary"
            text-color="accent"
            unelevated
            no-caps
            @click="autoGenerateEventOrder"
          >
            <q-icon
              name="mdi-refresh-auto"
              color="accent"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Auto Order
          </q-btn> -->

          <q-btn
            v-if="addEvent"
            class="float-right"
            flat
            @click="addEvent = false"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>

          <q-btn
            v-if="editEvent"
            class="float-right"
            flat
            @click="$router.push(`/competitions/${data.id}`)"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>
          <q-input
            v-if="!addEvent && !editEvent"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="eventsSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!addEvent && !editEvent"
        class="col-12"
        style="height: calc(100vh - 285px) !important"
      >
        <eventsSortableDatatable
          :eventsSearch="eventsSearch"
        ></eventsSortableDatatable>
        <!-- <datatable
          :filter="eventsSearch"
          :flat="true"
          :data="eventsList"
          :columns="eventColumns"
          :disableSearchCols="['playerLabels']"
          @rowDoubleClick="eventDoubleClick"
        >
          <template slot="body-cell-event_no" slot-scope="data">
            <q-td :props="data.props">
              <q-input
                label=""
                v-model="data.props.row.event_no"
                dense
                @blur="saveEventFromGrid(data.props.row)"
              ></q-input>
            </q-td>
          </template>
          <template slot="body-cell-event_name" slot-scope="data">
            <q-td :props="data.props">
              <b>{{ data.props.row.event_name }}</b>
              <br />

              <span style="color: gray; font-size: 8pt">
                {{ data.props.row.division_name }} /
                {{ data.props.row.gender }} {{ data.props.row.age_min }}-{{
                  data.props.row.age_max
                }}yrs
              </span>
            </q-td>
          </template>
          <template slot="body-cell-playerLabels" slot-scope="data">
            <q-td :props="data.props">
              <q-icon name="mdi-file-certificate-outline" size="sm"></q-icon>
              <q-tooltip>
                <div>Player Labels</div>
                <div
                  v-for="(label, index) in JSON.parse(
                    data.props.row.playerLabels
                  )"
                  :key="`label_${index}`"
                >
                  {{ label.name }} -
                  {{ label.twoHundredMeter == 1 ? "200m Badge," : "" }}
                  {{ label.patrolSupport == 1 ? "PS or SLG," : "" }}
                  {{ label.slg == 1 ? "SLG Award," : "" }}
                  {{ label.crew == 1 ? "IRB Crew," : "" }}
                  {{ label.driver == 1 ? "IRB Driver," : "" }}
                  {{ label.mixed == 1 ? "Mixed Gender," : "" }}
                  {{ label.noMaxAge == 1 ? "Open Age," : "" }}
                  {{ label.required == 1 ? "Required" : "" }}
                </div>
              </q-tooltip>
            </q-td>
          </template>
          <template slot="body-cell-entriesOpenOverride" slot-scope="data">
            <q-td :props="data.props">
              <q-icon
                :name="
                  `mdi-${
                    data.props.row.entriesOpenOverride ||
                    (entriesOpen && data.props.row.currentStep == 0)
                      ? 'check-circle-outline'
                      : 'close-circle-outline'
                  }`
                "
                :color="
                  data.props.row.entriesOpenOverride ||
                  (entriesOpen && data.props.row.currentStep == 0)
                    ? 'positive'
                    : 'negative'
                "
                size="sm"
              >
                <q-tooltip>
                  Entries are
                  {{
                    data.props.row.entriesOpenOverride ||
                    (entriesOpen && data.props.row.currentStep == 0)
                      ? "Open"
                      : "Closed"
                  }}
                </q-tooltip>
              </q-icon>
            </q-td>
          </template>

          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="duplicatingEventID == data.props.row.id"
                @click="duplicateEvent(data.props.row.id)"
                round
                flat
              >
                <q-icon name="mdi-content-copy"></q-icon>
                <q-tooltip>Duplicate</q-tooltip>
              </q-btn>
              <q-btn
                :loading="removingEventID == data.props.row.id"
                @click="removeEvent(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Event</q-tooltip>
              </q-btn>
              <q-btn dense round flat class="float-right" color="black">
                <q-icon name="mdi-dots-vertical"></q-icon>
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      @click="openEntries(data.props.row)"
                      clickable
                      v-close-popup
                    >
                      <q-item-section>
                        {{
                          !data.props.row.entriesOpenOverride
                            ? "Keep Entries Open"
                            : "Revert to Competition Entries Dates"
                        }}
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </q-td>
          </template>
        </datatable> -->
      </div>
      <div v-if="addEvent" class="col-12">
        <eventForm
          ref="addEventForm"
          forCompetition
          :competitionType="formData.competition_type"
          @close="addEvent = false"
          @loadingStateChanged="state => (addEventLoading = state)"
        />
      </div>

      <div v-if="addEvent" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="addEventLoading"
          @click="submitEventToAdd"
        >
          <q-icon
            name="mdi-plus-circle"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Add Event
        </q-btn>
      </div>
      <div v-if="editEvent" class="col-12">
        <eventForm
          ref="editEventForm"
          forCompetition
          :competitionType="formData.competition_type"
          :id="$route.params.events_id"
          @close="$router.push(`/competitions/${data.id}`)"
          @loadingStateChanged="state => (editEventLoading = state)"
        />
      </div>
      <div v-if="editEvent" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="editEventLoading"
          @click="saveEvent"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save Event
        </q-btn>
      </div>
    </div>
    <div class="row" v-if="tab == 'questions'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Competition Questions
          <q-btn
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addQuestion"
            :loading="addQuestionLoading"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>
          <q-input
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="questionsSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div class="col-12" style="height: calc(100vh - 285px) !important">
        <datatable
          :filter="questionsSearch"
          :flat="true"
          :data="questions"
          :columns="questionColumns"
          @rowDoubleClick="questionDoubleClick"
        >
          <template slot="body-cell-type" slot-scope="data">
            <q-td :props="data.props">
              <q-select
                v-model="data.props.row.type"
                label="Type"
                v-bind="siteCFG.fields.general"
                :options="questionTypes"
                option-label="questionName"
                option-value="id"
                emit-value
                map-options
                dense
                @input="updateQuestionRow(data.props.row, true)"
              >
              </q-select>
            </q-td>
          </template>
          <template slot="body-cell-name" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.name"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-email" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.email"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-mobile" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.mobile"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-rangeType" slot-scope="data">
            <q-td :props="data.props">
              <q-select
                v-model="data.props.row.rangeType"
                label="Range"
                v-bind="siteCFG.fields.general"
                :options="questionRangeTypes"
                option-label="label"
                option-value="value"
                emit-value
                map-options
                dense
                @input="updateQuestionRow(data.props.row)"
              >
              </q-select>
            </q-td>
          </template>
          <template slot="body-cell-range" slot-scope="data">
            <q-td :props="data.props">
              <q-select
                v-if="data.props.row.rangeType == 0"
                v-model="data.props.row.range"
                label="Range"
                v-bind="siteCFG.fields.general"
                :options="questionRangeOptions"
                option-label="label"
                option-value="value"
                emit-value
                map-options
                dense
                @input="updateQuestionRow(data.props.row)"
              >
              </q-select>
              <div class="row">
                <div class="col-6 q-px-xs">
                  <q-input
                    label="Min"
                    v-if="data.props.row.rangeType == 1"
                    v-bind="siteCFG.fields.general"
                    type="number"
                    dense
                    v-model="data.props.row.min"
                    @input="updateQuestionRow(data.props.row)"
                  ></q-input>
                </div>
                <div class="col-6 q-px-xs">
                  <q-input
                    label="Max"
                    v-if="data.props.row.rangeType == 1"
                    v-bind="siteCFG.fields.general"
                    type="number"
                    dense
                    v-model="data.props.row.max"
                    @input="updateQuestionRow(data.props.row)"
                  ></q-input>
                </div>
              </div>
            </q-td>
          </template>
          <template slot="body-cell-competitor" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.competitor"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-teams" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.teams"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-competition" slot-scope="data">
            <q-td :props="data.props">
              <q-checkbox
                :true-value="1"
                :false-value="0"
                dense
                indeterminate-value="no-value"
                label=""
                v-model="data.props.row.competition"
                @input="updateQuestionRow(data.props.row)"
              />
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingQuestionID == data.props.row.id"
                @click="removeQuestion(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Question</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
    <div class="row" v-if="tab == 'limits'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">Limits</h6>
      </div>
      <div class="col-12 q-pa-xs">
        <q-card flat bordered>
          <div class="row q-pa-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Limit Options</h6>
            </div>
            <div class="col-12 col-sm-6 col-md-4">
              <q-select
                label="Limit Type"
                :options="competitionLimitTypes"
                v-model="formData.limitType"
              >
              </q-select>
            </div>
          </div>
        </q-card>
      </div>
      <div
        class="col-12 col-md-6 q-px-xs"
        v-if="formData.limitType == 'Specific'"
      >
        <q-card flat bordered>
          <div class="row q-pa-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">
                CRM Associations
                <q-input
                  style="max-width: 70%"
                  filled
                  class="float-right"
                  v-model="associationsCRMSearch"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"> </q-icon>
                  </template>
                </q-input>
              </h6>
            </div>
            <div class="col-12">
              <div
                class="col-12"
                style="height: calc(100vh - 490px) !important"
              >
                <datatable
                  :filter="associationsCRMSearch"
                  :flat="true"
                  :data="crmAssociations"
                  :columns="associationColumns"
                >
                  <template slot="body-cell-selected" slot-scope="data">
                    <q-td :props="data.props">
                      <q-checkbox
                        v-model="limits[data.props.row.id]"
                        :true-value="1"
                        :false-value="0"
                        indeterminate-value="no-value"
                        label=""
                        @input="updateAssociationLimit(data.props.row.id)"
                      >
                      </q-checkbox>
                    </q-td>
                  </template>
                  <template slot="body-cell-cap" slot-scope="data">
                    <q-td :props="data.props">
                      <q-img
                        v-if="data.props.row.capUrl"
                        :src="data.props.row.capUrl"
                        width="40px"
                        contain
                        class="q-ml-sm"
                      >
                      </q-img>
                    </q-td>
                  </template>
                </datatable>
              </div>
            </div>
          </div>
        </q-card>
      </div>
      <div
        class="col-12 col-md-6 q-px-xs"
        v-if="formData.limitType == 'Specific'"
      >
        <q-card flat bordered>
          <div class="row q-pa-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">
                Added Associations
                <q-input
                  style="max-width: 70%"
                  filled
                  class="float-right"
                  v-model="associationsAddedSearch"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"> </q-icon>
                  </template>
                </q-input>
              </h6>
            </div>
            <div class="col-12">
              <div
                class="col-12"
                style="height: calc(100vh - 490px) !important"
              >
                <datatable
                  :filter="associationsAddedSearch"
                  :flat="true"
                  :data="nonCrmAssociations"
                  :columns="associationColumns"
                >
                  <template slot="body-cell-selected" slot-scope="data">
                    <q-td :props="data.props">
                      <q-checkbox
                        v-model="limits[data.props.row.id]"
                        :true-value="1"
                        :false-value="0"
                        indeterminate-value="no-value"
                        label=""
                        @input="updateAssociationLimit(data.props.row.id)"
                      >
                      </q-checkbox>
                    </q-td>
                  </template>
                  <template slot="body-cell-cap" slot-scope="data">
                    <q-td :props="data.props">
                      <q-img
                        v-if="data.props.row.capUrl"
                        :src="data.props.row.capUrl"
                        width="40px"
                        contain
                        class="q-ml-sm"
                      >
                      </q-img>
                    </q-td>
                  </template>
                </datatable>
              </div>
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <div class="row" v-show="tab == 'invoicing'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Invoicing sendInvoiceToAssociations

          <q-btn
            :label="
              previewClubInvoices
                ? 'Manage Invoice Settings'
                : 'Preview Club Invoices'
            "
            color="primary"
            no-caps
            class="float-right"
            @click="previewClubInvoices = !previewClubInvoices"
          ></q-btn>
          <q-btn
            label="Create Xero Invoices"
            color="primary"
            no-caps
            class="float-right q-mr-sm"
            @click="sendClubInvoices"
          ></q-btn>
        </h6>
      </div>
      <div class="col-12" v-show="!previewClubInvoices">
        <invoicingForm
          v-if="tab == 'invoicing' || invoiceTabOpened == true"
          ref="invoiceForm"
        />
      </div>
      <div class="col-12" v-if="previewClubInvoices">
        Previewing Club Invoices
        <div class="row">
          <div class="col-12">
            <autocomplete
              dense
              label="Association"
              :items="invoiceObjects"
              :itemsLoading="invoiceObjectsLoading"
              option_label="association_name"
              option_value="id"
              :id="previewClubInvoice_id"
              @changed="
                val => {
                  previewClubInvoice_id = val;
                }
              "
            />
          </div>
          <div class="col-12" v-if="previewClubInvoiceData">
            <div class="row">
              <div class="col-12 col-md-6 q-pa-xs">
                <q-card flat bordered style="height: 100%">
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <h6 class="q-my-none q-mt-xs">Competition Fees</h6>
                    </div>
                    <div class="col-12">
                      <table style="width: 100%">
                        <tr style="text-align: left">
                          <th>Fee</th>
                          <th>Calculation</th>
                          <th>Total</th>
                        </tr>
                        <tr>
                          <td>Early Entry</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.compEarlyEntry
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.earlyCompetitionEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.compEarlyEntry
                                ) *
                                  previewClubInvoiceData.earlyCompetitionEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Standard Entry</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.compStandardEntry
                              )
                            }}
                            X
                            {{
                              previewClubInvoiceData.standardCompetitionEntries
                            }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.compStandardEntry
                                ) *
                                  previewClubInvoiceData.standardCompetitionEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Late Entry</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.compLateEntry
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.lateCompetitionEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.compLateEntry
                                ) *
                                  previewClubInvoiceData.lateCompetitionEntries
                              )
                            }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </q-card>
              </div>
              <div class="col-12 col-md-6 q-pa-xs">
                <q-card flat bordered>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <h6 class="q-my-none q-mt-xs">Per Event</h6>
                    </div>
                    <div class="col-12">
                      <table style="width: 100%">
                        <tr style="text-align: left">
                          <th>Fee</th>
                          <th>Calculation</th>
                          <th>Total</th>
                        </tr>
                        <tr>
                          <td>Early Entry Individual</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventEarlyEntryInd
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.earlyIndividualEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventEarlyEntryInd
                                ) *
                                  previewClubInvoiceData.earlyIndividualEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Early Entry Team</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventEarlyEntryTeam
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.earlyTeamEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventEarlyEntryTeam
                                ) * previewClubInvoiceData.earlyTeamEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Standard Entry Individual</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventStandardEntryInd
                              )
                            }}
                            X
                            {{
                              previewClubInvoiceData.standardIndividualEntries
                            }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventStandardEntryInd
                                ) *
                                  previewClubInvoiceData.standardIndividualEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Standard Entry Team</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventStandardEntryTeam
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.standardTeamEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventStandardEntryTeam
                                ) * previewClubInvoiceData.standardTeamEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Late Entry Individual</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventLateEntryInd
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.lateIndividualEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventLateEntryInd
                                ) * previewClubInvoiceData.lateIndividualEntries
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Late Entry Team</td>
                          <td>
                            {{
                              moneyFormatter(
                                previewClubInvoiceData.eventLateEntryTeam
                              )
                            }}
                            X
                            {{ previewClubInvoiceData.lateTeamEntries }}
                          </td>
                          <td>
                            {{
                              moneyFormatter(
                                parseFloat(
                                  previewClubInvoiceData.eventLateEntryTeam
                                ) * previewClubInvoiceData.lateTeamEntries
                              )
                            }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </q-card>
              </div>
              <div class="col-12 q-px-xs">
                <q-card flat bordered>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <h6 class="q-my-none q-mt-xs">Additional</h6>
                    </div>
                    <div class="col-12" style="height: 285px">
                      <datatable
                        :filter="additionalFeesSearch"
                        :flat="true"
                        :data="previewClubInvoiceData.additionalCharges"
                        :columns="additionalChargesColumns"
                      >
                        <template slot="body-cell-ammt" slot-scope="data">
                          <q-td :props="data.props">
                            {{ moneyFormatter(data.props.row.ammt) }}
                          </q-td>
                        </template>
                        <template slot="body-cell-qty" slot-scope="data">
                          <q-td :props="data.props">
                            {{
                              data.props.row.athlete == 1
                                ? data.props.row.athletes
                                : data.props.row.indEvent == 1
                                ? data.props.row.individualEventEntries
                                : data.props.row.teamEventEntires
                            }}
                          </q-td>
                        </template>
                        <template slot="body-cell-total" slot-scope="data">
                          <q-td :props="data.props">
                            {{
                              data.props.row.athlete == 1
                                ? moneyFormatter(
                                    parseFloat(data.props.row.ammt) *
                                      data.props.row.athletes
                                  )
                                : data.props.row.indEvent == 1
                                ? moneyFormatter(
                                    parseFloat(data.props.row.ammt) *
                                      data.props.row.individualEventEntries
                                  )
                                : moneyFormatter(
                                    parseFloat(data.props.row.ammt) *
                                      data.props.row.teamEventEntires
                                  )
                            }}
                          </q-td>
                        </template>
                      </datatable>
                    </div>
                  </div>
                </q-card>
              </div>
              <div class="col-12 col-md-6 q-pa-xs">
                <q-card flat bordered>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <h6 class="q-my-none q-mt-xs">
                        <div class="row">
                          <div style="width: 140px">Per Division</div>
                        </div>
                      </h6>
                    </div>
                    <div class="col-12" style="height: 235px">
                      <datatable
                        :filter="divisionChargesSearch"
                        :flat="true"
                        :data="previewClubInvoiceData.divisionCharges"
                        :columns="divisionChargesColumns"
                      >
                        <template slot="body-cell-ammt" slot-scope="data">
                          <q-td :props="data.props">
                            {{ moneyFormatter(data.props.row.ammt) }}
                          </q-td>
                        </template>
                        <template slot="body-cell-total" slot-scope="data">
                          <q-td :props="data.props">
                            {{
                              moneyFormatter(
                                parseFloat(data.props.row.ammt) *
                                  data.props.row.entries
                              )
                            }}
                          </q-td>
                        </template>
                      </datatable>
                    </div>
                  </div>
                </q-card>
              </div>
              <div class="col-12 col-md-6 q-pa-xs">
                <q-card flat bordered>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <h6 class="q-my-none q-mt-xs">
                        <div class="row">
                          <div style="width: 140px">Per Event</div>
                        </div>
                      </h6>
                    </div>
                    <div class="col-12" style="height: 235px">
                      <datatable
                        :filter="eventChargesSearch"
                        :flat="true"
                        :data="previewClubInvoiceData.eventCharges"
                        :columns="eventChargesColumns"
                      >
                        <template slot="body-cell-ammt" slot-scope="data">
                          <q-td :props="data.props">
                            {{ moneyFormatter(data.props.row.ammt) }}
                          </q-td>
                        </template>
                        <template slot="body-cell-total" slot-scope="data">
                          <q-td :props="data.props">
                            {{
                              moneyFormatter(
                                parseFloat(data.props.row.ammt) *
                                  data.props.row.entries
                              )
                            }}
                          </q-td>
                        </template>
                      </datatable>
                    </div>
                  </div>
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="tab == 'reminders'">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Reminders</h6>
          </div>
          <div class="col-12 q-pa-sm">
            <div class="row items-center">
              <div class="col-auto q-px-sm">
                <q-select
                  style="width: 200px"
                  label="Reminder Type"
                  v-bind="siteCFG.fields.general"
                  v-model="selectedReminderOption"
                  :options="reminderOptions"
                  @input="changeReminderOption"
                ></q-select>
              </div>
              <div class="col q-px-sm text-right">
                <q-btn
                  :disable="!selectedReminderOption"
                  label="Test Email"
                  color="primary"
                  @click="sendTestReminderEmails"
                  :loading="emailSending"
                  no-caps
                ></q-btn>
              </div>
              <div class="col-auto q-px-sm">
                <q-btn
                  label="Send to Selected Clubs"
                  class="full-width"
                  color="primary"
                  no-caps
                  @click="sendReminderEmails"
                  :disable="!selectedReminderOption"
                  :loading="emailSending"
                ></q-btn>
              </div>
            </div>
          </div>
          <div class="col-12 q-pa-sm">
            <q-input
              label="Subject"
              v-bind="siteCFG.fields.general"
              v-model="reminder.subject"
              :disable="!selectedReminderOption"
            >
            </q-input>
          </div>
          <div class="col-12 q-pa-sm">
            <span>Content</span>
            <q-editor
              :disable="!selectedReminderOption"
              v-model="reminder.content"
              :dense="$q.screen.lt.md"
              :toolbar="[
                [
                  {
                    label: $q.lang.editor.align,
                    icon: $q.iconSet.editor.align,
                    fixedLabel: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                  },
                  {
                    label: $q.lang.editor.align,
                    icon: $q.iconSet.editor.align,
                    fixedLabel: true,
                    options: ['left', 'center', 'right', 'justify']
                  }
                ],
                [
                  'bold',
                  'italic',
                  'strike',
                  'underline',
                  'subscript',
                  'superscript'
                ],
                ['token', 'hr', 'link', 'custom_btn'],
                ['print', 'fullscreen'],
                [
                  {
                    label: $q.lang.editor.formatting,
                    icon: $q.iconSet.editor.formatting,
                    list: 'no-icons',
                    options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                  },
                  {
                    label: $q.lang.editor.fontSize,
                    icon: $q.iconSet.editor.fontSize,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'size-1',
                      'size-2',
                      'size-3',
                      'size-4',
                      'size-5',
                      'size-6',
                      'size-7'
                    ]
                  },
                  {
                    label: $q.lang.editor.defaultFont,
                    icon: $q.iconSet.editor.font,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'default_font',
                      'arial',
                      'arial_black',
                      'comic_sans',
                      'courier_new',
                      'impact',
                      'lucida_grande',
                      'times_new_roman',
                      'verdana'
                    ]
                  },
                  'removeFormat'
                ],
                ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                ['undo', 'redo'],
                ['viewsource']
              ]"
              :fonts="{
                arial: 'Arial',
                arial_black: 'Arial Black',
                comic_sans: 'Comic Sans MS',
                courier_new: 'Courier New',
                impact: 'Impact',
                lucida_grande: 'Lucida Grande',
                times_new_roman: 'Times New Roman',
                verdana: 'Verdana'
              }"
            />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 bg-gray-3">
        <div class="row">
          <div class="col-12" style="height: calc(100vh - 240px) !important">
            <datatable
              :filter="''"
              :flat="true"
              :data="crmAssociations"
              :columns="associationColumns"
              selection="multiple"
              ref="reminderClubTable"
            >
              <template slot="body-cell-cap" slot-scope="data">
                <q-td :props="data.props">
                  <q-img
                    v-if="data.props.row.capUrl"
                    :src="data.props.row.capUrl"
                    width="40px"
                    contain
                    class="q-ml-sm"
                  >
                  </q-img>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="tab == 'downloads'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">Reports</h6>
      </div>
      <div class="col-12 q-pa-sm">
        <q-btn
          label="Invoice Report"
          icon="mdi-download"
          color="secondary"
          class="text-black"
          @click="downloads('invoiceReport')"
        ></q-btn>
      </div>
      <div class="col-12 q-pa-sm">
        <q-btn
          label="Entries Report"
          icon="mdi-download"
          color="secondary"
          class="text-black"
          @click="downloads('CompetitionEntriesSummary')"
        ></q-btn>
      </div>
      <div class="col-12 q-pa-sm">
        <q-btn
          label="Support Members Report"
          icon="mdi-download"
          color="secondary"
          class="text-black"
          @click="downloads('SupportMembers')"
        ></q-btn>
      </div>
      <template v-if="formData.competition_type == 'POOL'">
        <div class="col-12">
          <q-separator class="q-my-md" />
          <h6 class="q-my-none q-mt-xs">Pool Exports</h6>
        </div>
        <div class="col-12 q-pa-sm">
          <q-btn
            label="HY3 Meet Entries Export"
            icon="mdi-download"
            color="secondary"
            class="text-black"
            :loading="poolExportLoading.hy3"
            @click="downloadHy3"
          ></q-btn>
        </div>
        <div class="col-12 q-pa-sm">
          <q-btn
            label="Lenex Events Export"
            icon="mdi-download"
            color="secondary"
            class="text-black"
            :loading="poolExportLoading.lenexEvents"
            @click="downloadLenexEvents"
          ></q-btn>
        </div>
        <div class="col-12 q-pa-sm">
          <q-btn
            label="Lenex Entries Export"
            icon="mdi-download"
            color="secondary"
            class="text-black"
            :loading="poolExportLoading.lenexEntries"
            @click="downloadLenexEntries"
          ></q-btn>
        </div>
      </template>
    </div>
    <div class="row" v-if="tab == 'entries'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Competition Entries
          <q-btn
            icon="mdi-download"
            flat
            class="text-black secondary"
            @click="downloads('CompetitionEntriesTableMirror')"
          ></q-btn>
          <q-input
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="entriesSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div class="col-12" style="height: calc(100vh - 285px) !important">
        <datatable
          :filter="entriesSearch"
          :flat="true"
          :data="entries"
          :loading="entriesLoading"
          :columns="entriesColumns"
        >
          <template slot="body-cell-capUrl" slot-scope="data">
            <q-td :props="data.props">
              <q-img
                v-if="data.props.row.capUrl"
                :src="data.props.row.capUrl"
                style="width: 40px"
                contain
                class="q-ml-sm float-right"
              >
              </q-img>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
  </q-form>
</template>

<script lang="js">
  import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
  import eventsSortableDatatable from "@/components/datatable/eventsSortableDatatable.vue";
  import eventForm from "@/components/events/eventForm.vue";
  import assignPointsTable from "@/components/pointsTable/assignPointsTable.vue";
  import invoicingForm from "@/components/invoicing/invoicingForm.vue"
  import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
  // import tiptap from "@/components/tiptap/tiptap.vue";
  import moment from "moment";
  import api from "@/api.js";



  export default {
    components: { datatable, eventForm, assignPointsTable, invoicingForm, autocomplete, eventsSortableDatatable },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        competitionTypes: "settings/competitionTypes",
        poolLengthOptions: "settings/poolLengthOptions",
        competitionStatusOptions: "settings/competitionStatusOptions",
        data: "competitions/current",
        dataLoading: "competitions/currentLoading",
        divisions: "divisions/list",
        divisionsLoading: "divisions/listLoading",
        events: "events/listForCompetition",
        eventsLoading: "events/listForCompetitionLoading",
        sessions: "sessions/listForCompetition",
        sessionsLoading: "sessions/listForCompetitionLoading",
        arenas: "arenas/listForCompetition",
        arenasLoading: "arenas/listForCompetitionLoading",
        questions: "questions/listForCompetition",
        questionsLoading: "questions/listForCompetitionLoading",
        questionTypes: "questionTypes/list",
        questionRangeOptions: "settings/questionRangeOptions",
        questionRangeTypes: "settings/questionRangeTypes",
        crmAssociations: "associations/crm",
        nonCrmAssociations: "associations/nonCrm",
        competitionLimitTypes: "settings/competitionLimitTypes",
        limits: "competitions/limits",
        invoiceObjects: "xeroSettings/invoiceObjects",
        invoiceObjectsLoading: "xeroSettings/invoiceObjectsLoading",
        entries: "competitions/entriesList",
        entriesLoading: "competitions/entriesListLoading",

      }),
      entriesOpen: function () {
        return moment(this.formData.entriesCloseDate) > moment()
      },
      entriesColumns: function () {
        return [
          {
            name: "name",
            label: "Name",
            align: "left",
            field: (row) => row,
            format: (val) => `${val.firstName} ${val.lastName}`,
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "birthDate",
            label: "DOB",
            align: "left",
            field: "birthDate",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "gender",
            label: "Gender",
            align: "left",
            field: "gender",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "division",
            label: "Division",
            align: "left",
            field: "birthDate",
            format: (val, row) => {
              if (this.divisions) {
                let year = moment().format("YYYY");
                let reference = moment(`${year}-09-30`);
                if (moment(`${year}-07-01`) > moment()) {
                  reference = reference.subtract(1, "years");
                }
                let age = reference.diff(val, "years", false);
                let div = this.divisions.find(
                  (d) =>
                    d.division_age_min <= age &&
                    d.age_max >= age &&
                    row.gender == d.gender
                );
                return div ? div.division_name : "No Division";
              } else {
                return "";
              }
            },
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sort: (a, b, rowA, rowB) => {
              let year = moment().format("YYYY");
              let reference = moment(`${year}-09-30`);
              if (moment(`${year}-07-01`) > moment()) {
                reference = reference.subtract(1, "years");
              }

              let ageA = reference.diff(rowA.birthDate, "years", false);
              let ageB = reference.diff(rowB.birthDate, "years", false);

              if (ageA == ageB) {
                return rowA.gender.localeCompare(rowB.gender);
              } else {
                return ageA - ageB;
              }
            },

            sortable: true,
          },
          {
            name: "capUrl",
            label: "",
            align: "left",
            field: "capUrl",
            style:
              "min-width: 80px;max-width: 80px; width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "association_name",
            label: "Club",
            align: "left",
            field: "association_name",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "emailAddress",
            label: "Email",
            align: "left",
            field: "emailAddress",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "mobilePhone",
            label: "Mobile Phone",
            align: "left",
            field: "mobilePhone",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          // {
          //   name: "actions",
          //   label: "Actions",
          //   align: "left",
          //   sortable: false,
          // },
        ];
      },
    },
    props: {
      id: {
        default: null,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
      $route: function () {
        this.handleRoute();
      },
      events: function () {
        this.sortEventsList();
      },
      tab: function() {
        if (this.tab == 'invoicing') {
          this.invoiceTabOpened = true
        }

      },
      invoiceObjects: function() {
        if(this.previewClubInvoice_id) {
          this.previewClubInvoiceData = JSON.parse(JSON.stringify(this.invoiceObjects.find((i) => i.id == this.previewClubInvoice_id)));
        }
      },
      previewClubInvoice_id: function() {
        this.previewClubInvoiceData = JSON.parse(JSON.stringify(this.invoiceObjects.find((i) => i.id == this.previewClubInvoice_id)));
      }
    },
    data: () => ({
      // Extra Data
      formData: {
        teamsPlayersEntries: 0,
        multipleAthletesPerEvent: 0,
        multipleEventsPerAthlete: 0,
        fullPlayerListRequired: 0,
        groupEventOptionsEnabled: 0,
        idPhotosRequired: 0,
        qualifyingTimesOrMarks: 0,
        showEnterAllEventsButton: 0,
        reserveEvents: 15,
        invoicing: 0,
        showEntriesToPublic: 0,
        status: "DRAFT",
        entryInformationSection: "",
        lr_showPoints: 1,
lr_showMedals: 1,
lr_showPAndMAfterFinished: 0,
      },
      firstModel: 5,
      tab: "general",
      poolExportLoading: {
        hy3: false,
        lenexEvents: false,
        lenexEntries: false,
      },
      statusColors: {
        DRAFT: "primary",
        LIVE: "positive",
        ARCHIVED: "blue-grey-8"
      },

      // INVOICING

      invoiceTabOpened: false,
      previewClubInvoices: false,
      previewClubInvoice_id: null,
      previewClubInvoiceData: null,

      additionalFeesSearch: "",
      additionalChargesColumns: [
        {
          name: "desc",
          label: "Description",
          align: "left",
          field: "desc",
          style:
            "min-width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "ammt",
          label: "Ammount",
          align: "left",
          field: "ammt",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "qty",
          label: "Qty.",
          align: "left",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "total",
          label: "Total",
          align: "left",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],

      divisionChargesSearch: "",
      divisionChargesColumns: [
        {
          name: "division_name",
          label: "Division",
          align: "left",
          field: "division_name",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "ammt",
          label: "Ammount",
          align: "left",
          field: "ammt",
          style:
            "min-width: 100px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "entries",
          label: "Entries",
          align: "left",
          field: "entries",
          style:
            "min-width: 100px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "total",
          label: "Total",
          align: "left",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],

      eventChargesSearch: "",
      eventChargesColumns: [
        {
          name: "event_name",
          label: "Division",
          align: "left",
          field: "event_name",
          style:
            "min-width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "ammt",
          label: "Ammount",
          align: "left",
          field: "ammt",
          style:
            "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "entries",
          label: "Entries",
          align: "left",
          field: "entries",
          style:
            "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "total",
          label: "Total",
          align: "left",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],

      // Croppa
      myCroppa: {},
      changeImage: false,

      // Entries
      entriesSearch: "",

      // Divisions
      columns: [
        {
          name: "division_name",
          label: "Division",
          align: "left",
          field: "division_name",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "gender",
          label: "Gender",
          align: "left",
          field: "gender",
          format: (val) =>
            val != null
              ? val == "M"
                ? "Male"
                : val == "F"
                ? "Female"
                : "Mixed"
              : "",
          sortable: true,
        },
        {
          name: "age",
          label: "Age Max",
          align: "left",
          field: (row) => row,
          format: (val) => `${val.age_min}-${val.age_max}`,
          sortable: true,
        },
        {
          name: "minCombinedAge",
          label: "Combined Age",
          align: "left",
          field: "minCombinedAge",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "code",
          label: "Code",
          align: "left",
          field: "code",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "sort",
          label: "Sort",
          align: "left",
          field: "sort",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],
      addDivision: false,
      addDivisionLoading: false,
      divisionsSearch: "",
      removingDivisionLinkID: null,

      // Events
      eventColumns: [
        {
          name: "event_no",
          label: "#",
          align: "left",
          field: "event_no",
          style:
            "min-width: 30px;max-width: 30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "event_name",
          label: "Event/Division",
          align: "left",
          field: "event_name",
          style:
            "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "team_size_max",
          label: "Team Size",
          align: "left",
          field: "team_size_max",
          format: (val, row) => {
            if (row.playerLabels) {
              return JSON.parse(row.playerLabels).length;
            } else {
              return 0;
            }
          },
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "discipline_name",
          label: "Discipline",
          align: "left",
          field: "discipline_name",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "Fee",
          label: "Fee / Penalty",
          align: "left",
          field: "fee",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
         {
          name: "playerLabels",
          label: "Player Labels",
          align: "left",
          field: "playerLabels",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
         {
          name: "entriesOpenOverride",
          label: "Entries Open",
          align: "left",
          field: "entriesOpenOverride",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],
      addEvent: false,
      addEventLoading: false,
      eventsSearch: "",
      removingEventID: null,
      duplicatingEventID: null,
      editEvent: false,
      editEventLoading: false,
      eventsList: [],

      // Sessions
      sessionColumns: [
        {
          name: "idx",
          label: "Order",
          align: "left",
          field: "idx",
          style:
            "min-width: 100px;max-width: 100px;width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",

          sortable: true,
        },
        {
          name: "active",
          label: "Status",
          align: "left",
          field: "active",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: false,
        },
      ],
      addSessionLoading: false,
      sessionsSearch: "",
      removingSessionID: null,
      editSessionLoading: false,
      settingSessionActive: false,

      // Arena
      arenaColumns: [
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",

          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: false,
        },
      ],
      addArenaLoading: false,
      arenasSearch: "",
      removingArenaID: null,
      editArenaLoading: false,
      settingArenaActive: false,

      // Questions
      questionColumns: [
        {
          name: "type",
          label: "Type",
          align: "left",
          field: "type",
          style:
            "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "email",
          label: "Email",
          align: "left",
          field: "email",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "mobile",
          label: "Mobile",
          align: "left",
          field: "mobile",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },

        {
          name: "rangeType",
          label: "Range Type",
          align: "left",
          field: "rangeType",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "range",
          label: "Range",
          align: "left",
          field: "range",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "competitor",
          label: "Competitor",
          align: "left",
          field: "competitor",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "teams",
          label: "Teams",
          align: "left",
          field: "teams",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "competition",
          label: "Competition",
          align: "left",
          field: "competition",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],

      // Association
      associationColumns: [
        {
          name: "selected",
          label: "",
          align: "left",

          style:
            "min-width: 30px;max-width: 30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "association_name",
          label: "Name",
          align: "left",
          field: "association_name",
          style:
            "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "cap",
          label: "Cap",
          align: "left",

          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
      ],
      addAssociation: false,
      addAssociationLoading: false,
      associationsCRMSearch: "",
      associationsAddedSearch: "",
      removingAssociationID: null,
      editAssociation: false,
      editAssociationLoading: false,

      addQuestionLoading: false,
      questionsSearch: "",
      removingQuestionID: null,
      editQuestionLoading: false,



      // Reminders
      reminderOptions: [
        {
          label: "Entered",
          subject: "Entered Competition Confirmation - -competition_name-",
          content: "<p>Thank you for entering into -competition_name-</p> <p>You can click below for your Entries Report</p> -entriesReportLink- <p>or Log into waves Here</p> -siteLink-",
          link: "entered"
        },
        {
          label: "Entries Open",
          subject: "Entreis Open - -competition_name-",
          content: "<p>Entries for -competition_name- are now open. Please click the link below to enter members into the competition</p> -siteLink-",
          link: "entriesOpen"
        },
        {
          label: "Entries Closed",
          subject: "Entries Closed - -competition_name-",
          content: "<p>Entries for -competition_name- are now closed.</p> <p>You can click below for your Entries Report</p> -entriesReportLink- <p>or Log into waves Here</p> -siteLink-",
          link: "entriesClosed"
        },
        {
          label: "Players Due",
          subject: "Reminder - Players Lists Due for -competition_name-",
          content: "<p>The Entries for -competition_name- close -entriesCloseDate-. Please make sure all of your teams are Entered and confirmed</p> <p>The following Entries are incomplete</p> -incompleteEntries- <p>You can click below for your Entries Report</p> -entriesReportLink- <p>or Log into waves Here</p> -siteLink-",
          link: "playersDue"
        }
      ],
      selectedReminderOption: null,
      emailSending: false,
      reminder: {
        subject: "",
        content: ""
      }
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.handleRoute();
      this.$store.dispatch("competitions/loadByID", this.id);
      this.$store.dispatch("pointsTable/loadAll");
      this.$store.dispatch("divisions/loadAll", this.id);
      this.$store.dispatch("events/loadForCompetition", this.id);
      this.$store.dispatch("sessions/loadForCompetition", this.id);
      this.$store.dispatch("arenas/loadForCompetition", this.id);
      this.$store.dispatch("questions/loadForCompetition", this.id);
      this.$store.dispatch("questionTypes/loadAll");
      this.$store.dispatch("associations/loadAll");
      this.$store.dispatch("competitions/loadLimits", this.id);
      this.$store.dispatch("xeroSettings/loadAllInvoiceObjects", this.id);
      this.$store.dispatch(
          "competitions/loadAllEntries",
          this.id
        );
    },
  methods: {

    changeReminderOption() {
      console.log(1);
      this.reminder.subject = this.selectedReminderOption.subject;
      this.reminder.content = this.selectedReminderOption.content;
    },
    init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            teamsPlayersEntries: 0,
            multipleAthletesPerEvent: 0,
            multipleEventsPerAthlete: 0,
            fullPlayerListRequired: 0,
            groupEventOptionsEnabled: 0,
            idPhotosRequired: 0,
            qualifyingTimesOrMarks: 0,
            showEnterAllEventsButton: 0,
            reserveEvents: 15,
            invoicing: 0,
            showEntriesToPublic: 0,
            status: "DRAFT",
            entryInformationSection: "",
            lr_showPoints: 1,
            lr_showMedals: 1,
            lr_showPAndMAfterFinished: 0,
          };
        }
      },
      handleRoute() {
        if (this.$route.params.events_id) {
          this.editEvent = true;
        } else {
          this.editEvent = false;
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("competitions/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);
        if (this.myCroppa && this.myCroppa.imageSet) {
          this.formData.image = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete this.formData.image;
        }
        if (this.invoiceTabOpened) {
          this.$refs.invoiceForm.save();
        }
        this.$store
          .dispatch("competitions/save", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.changeImage = false;
              this.myCroppa = null;
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      submitDivisionToAdd() {
        this.$refs.addDivisionForm.addCompetitionToDivision(this.data.id);
      },
      divisionDoubleClick(row) {
        this.$router.push(`/management/divisions/${row.id}`);
      },
      removeDivision(id) {
        this.removingDivisionLinkID = id;
        this.$store
          .dispatch("divisions/removeFromCompetition", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      // Events
      submitEventToAdd() {
        this.$refs.addEventForm.addEventToCompetition(this.data.id);
      },
      saveEvent() {
        this.$refs.editEventForm.save();
      },
      saveEventFromGrid(data) {
        this.$store.dispatch("events/save", data).then((result) => {
          if (result.Result == "Success") {
            this.address = "";
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      eventDoubleClick(row) {
        this.$router.push(`/competitions/${this.data.id}/events/${row.id}`);
      },
      removeEvent(id) {
        this.removingEventID = id;
        this.$store
          .dispatch("events/removeFromCompetition", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      duplicateEvent(id) {
        this.duplicatingEventID = id;
        this.$store
          .dispatch("events/duplicateEvent", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            this.duplicatingEventID = null;
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      sortEventsList() {
        this.eventsList = JSON.parse(JSON.stringify(this.events))
          .sort((a, b) =>
            a.event_name > b.event_name ? 1 : b.event_name > a.event_name ? -1 : 0
          )
          .sort((a, b) =>
            a.event_no > b.event_no ? 1 : b.event_no > a.event_no ? -1 : 0
          );
      },

      // Sessions
      addSession() {
        this.addSessionLoading = true;
        this.$store
          .dispatch("sessions/new", { competitions_id: this.data.id })
          .then((result) => {
            this.addSessionLoading = false;
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      sessionDoubleClick(row) {
        // console.log(row);
      },
      updateSessionRow(row, typeChanged = false) {
        this.$store.dispatch("sessions/save", row).then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
    setSessionActive(row) {
        this.settingSessionActive = true
        this.$store.dispatch("sessions/setActive", {
          id: row.id,
          competitions_id: this.data.id,
        }).then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
        this.settingSessionActive = false
      },
      removeSession(id) {
        this.removingQuestionID = id;
        this.$store
          .dispatch("sessions/delete", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      // Arenas
      addArena() {
        this.addArenaLoading = true;
        this.$store
          .dispatch("arenas/new", { competitions_id: this.data.id })
          .then((result) => {
            this.addArenaLoading = false;
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      arenaDoubleClick(row) {
        // console.log(row);
      },
      updateArenaRow(row, typeChanged = false) {
        this.$store.dispatch("arenas/save", row).then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      removeArena(id) {
        this.removingQuestionID = id;
        this.$store
          .dispatch("arenas/delete", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      // Questions
      addQuestion() {
        this.addQuestionLoading = true;
        this.$store
          .dispatch("questions/new", { competitions_id: this.data.id })
          .then((result) => {
            this.addQuestionLoading = false;
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      questionDoubleClick(row) {
        // console.log(row);
      },
      updateQuestionRow(row, typeChanged = false) {
        if (typeChanged) {
          let typeData = this.questionTypes.find((qt) => qt.id == row.type);
          row = {
            type: typeData.id,
            name: typeData.name,
            email: typeData.email,
            mobile: typeData.mobile,
            rangeType: typeData.rangeType,
            range: typeData.range,
            competitor: typeData.competitor,
            teams: typeData.teams,
            competition: typeData.competition,
            id: row.id,
            competitions_id: row.competitions_id,
          };
        }

        this.$store.dispatch("questions/save", row).then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      removeQuestion(id) {
        this.removingQuestionID = id;
        this.$store
          .dispatch("questions/removeFromCompetition", {
            id: id,
            competitions_id: this.data.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      updateAssociationLimit(id) {
        this.$store
          .dispatch("competitions/updateLimit", {
            associations_id: id,
            competitions_id: this.id,
            value: this.limits[id],
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      autoGenerateEventOrder() {
        this.$swal({
          title: "Warning",
          text: "You are about to re-order the events for this competition, this override any current ordering",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            // console.log(this.events);
            let eventsList = JSON.parse(JSON.stringify(this.events));
            eventsList.sort((a, b) =>
            a.event_name > b.event_name ? 1 : b.event_name > a.event_name ? -1 : 0
          )
          .sort((a, b) =>
            parseInt(a.age_min) > parseInt(b.age_min) ? 1 : parseInt(b.age_min) > parseInt(a.age_min) ? -1 : 0
          );

            // console.log(eventsList);
          }
        });
      },
      sendClubInvoices() {
        this.$swal({
          title: "Warning",
          text: "You are about to generate Xero invoices for the Associations, This is intended to be done After a competition has finished being run. Are you sure you wish to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.$store
          .dispatch("competitions/sendInvoiceToAssociations", {
            competitions_id: this.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: 'The Xero invoices were created and set to Draft',
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });

            // console.log(eventsList);
          }
        });
      },
      downloads(type) {
        switch (type) {
          case 'invoiceReport':
            window.open(
          `${api.defaults.baseURL}/competition/invoiceBuilder/download?competitions_id=${this.$route.params.id}`,
          "_blank"
        );
            break;

             case 'CompetitionEntriesSummary':
            window.open(
          `${api.defaults.baseURL}/report/download?competitions_id=${this.$route.params.id}&type=CompetitionEntriesSummary`,
          "_blank"
        );
            break;
            case 'SupportMembers':
            window.open(
          `${api.defaults.baseURL}/report/download?competitions_id=${this.$route.params.id}&type=SupportMembers`,
          "_blank"
        );
            break;

            case 'CompetitionEntriesTableMirror':
          window.open(
          `${api.defaults.baseURL}/report/download?competitions_id=${this.$route.params.id}&type=CompetitionEntriesTableMirror`,
          "_blank"
        );
            break;

          default:
            break;
        }

      },
      async downloadPoolExport({ loadingKey, endpoint, filename, mime, errorLabel }) {
        this.poolExportLoading[loadingKey] = true;
        try {
          const res = await api.get(endpoint, {
            params: { id: this.$route.params.id }
          });
          if (res.data && res.data.success) {
            const blob = new Blob([res.data.content], { type: mime });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
          } else {
            this.$q.notify({
              type: "negative",
              message: (res.data && res.data.errors && res.data.errors.join("\n")) || `Failed to generate ${errorLabel}`,
            });
          }
        } catch (err) {
          this.$q.notify({
            type: "negative",
            message: `Failed to download ${errorLabel}`,
          });
        } finally {
          this.poolExportLoading[loadingKey] = false;
        }
      },
      downloadHy3() {
        return this.downloadPoolExport({
          loadingKey: "hy3",
          endpoint: "hytek/createHy3FileForCompetition",
          filename: `${this.formData.competition_name || "competition"}.hy3`,
          mime: "application/octet-stream",
          errorLabel: "HY3 file",
        });
      },
      downloadLenexEvents() {
        return this.downloadPoolExport({
          loadingKey: "lenexEvents",
          endpoint: "lenex/createEventsFile",
          filename: `${this.formData.competition_name || "competition"}-events.lef`,
          mime: "application/xml",
          errorLabel: "Lenex events file",
        });
      },
      downloadLenexEntries() {
        return this.downloadPoolExport({
          loadingKey: "lenexEntries",
          endpoint: "lenex/createEntriesFile",
          filename: `${this.formData.competition_name || "competition"}-entries.lef`,
          mime: "application/xml",
          errorLabel: "Lenex entries file",
        });
      },
    sendTestReminderEmails() {
      let ids = this.$refs.reminderClubTable.selected.map((e) => e.id);
      this.$swal({
        title: "Warning",
        text: "You are about to send a Test email to yourself, are you sure you want to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then((res) => {
        if (res.value) {
  let payload = {
        competitions_id: this.formData.id,
        associations: [ids[0]],
        content: this.reminder.content,
        subject: this.reminder.subject,
        test: true
      };

          this.sendEmail(payload);
                }
      });

      },

      sendReminderEmails() {
              let ids = this.$refs.reminderClubTable.selected.map((e) => e.id);
              this.$swal({
        title: "Warning",
        text: "You are about to send an email to the selected clubs, are you sure you want to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
              }).then((res) => {
                if (res.value) {
        let payload = {
          competitions_id: this.formData.id,
          associations: ids,
          content: this.reminder.content,
          subject: this.reminder.subject

        };
        this.sendEmail(payload);
                }
      });

    },
    async sendEmail(payload) {
      this.emailSending = true;

      try {
        let result = await this.$store.dispatch('emails/sendEmail', {
          url: this.selectedReminderOption.link,
          payload: payload
        });
        this.$q.notify({
          position: "top-right",
          type: result.Result == 'Success' ? "positive" : "negative",
          message: result.Result == 'Success' ? result.Response.Message : "There was an error, Please try again later",
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later",
        });
      }

      this.emailSending = false;
    },

    },

  };
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}
</style>
